<div class="min-h-screen bg-surface px-4 py-4 text-text sm:px-8">
  <div
    class="mx-auto max-w-6xl overflow-hidden rounded-xl border border-subtle bg-surface shadow-card"
  >
    <app-navbar></app-navbar>
    <div class="px-4 pb-0 pt-0 sm:px-6 sm:pb-0 sm:pt-0">
      <router-outlet />
    </div>
    <div class="mt-6">
      <app-footer></app-footer>
    </div>
  </div>
</div>
